import useInView from "../../hooks/useInView";

export default function Reveal({ children, delay = 0, from = "bottom", className = "", style = {} }) {
  const [ref, inView] = useInView();
  const transforms = {
    bottom: "translateY(32px)",
    left:   "translateX(-24px)",
    right:  "translateX(24px)",
    none:   "none",
  };
  return (
    <div ref={ref} className={className} style={{
      opacity: inView ? 1 : 0,
      transform: inView ? "translate(0)" : transforms[from],
      transition: `opacity 0.75s cubic-bezier(.16,1,.3,1) ${delay}s, transform 0.75s cubic-bezier(.16,1,.3,1) ${delay}s`,
      ...style,
    }}>{children}</div>
  );
}
